import { ImportRepository } from '../repositories'

export interface UploadFileReqBo extends ImportRepository.UploadFileReqDto {}

/** 上傳類別資料 */
export async function uploadFile(params: UploadFileReqBo): Promise<void> {
  await ImportRepository.uploadFile(params)
}
  
export interface DeleteCarInfoByShippingNoReqBo extends ImportRepository.DeleteCarInfoByShippingNoReqDto {}

/** 依船次編號刪除整船資料 */
export async function deleteCarInfoByShippingNo(params: DeleteCarInfoByShippingNoReqBo): Promise<void> {
  await ImportRepository.deleteCarInfoByShippingNo(params)
}